import React, { useEffect, useState } from 'react';
import { bool, object, func } from 'prop-types';

import Modal from '../molecules/Modal';
import Text from '../atoms/Text';
import Box from '../atoms/Box';
import Button from '../atoms/Button';

import { useTranslate } from '../../translate/I18n';
import { Link } from '../../utils/router';
import SanitizedHTML from '../elements/SanitizedHTML';
import { useUserContext } from '../auth/hook/userContext';

import { abstractSessionStorage } from '../../utils/window/sessionStorage';
import { abstractLocalStorage } from '../../utils/window/localStorage';
import Img from '../atoms/ImgNext';
import { commonRoutes } from '../../routes';

const { general: { login, register } } = commonRoutes;

const ModalIncentivizeToRegister = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t, i18n } = useTranslate(['mission']);
  const user = useUserContext();
  const hasBeenIncentivizedDuringThisSession =
    abstractSessionStorage.getItem('hasBeenIncentivizedToRegister') === 'true';
  const wasLoggedInOnce = abstractLocalStorage.getItem('wasLoggedInOnce') === 'true';

  useEffect(() => {
    const _10Seconds = 10000;
    if (!user.isLoggedIn()) {
      setTimeout(function () {
        if (hasBeenIncentivizedDuringThisSession || wasLoggedInOnce) return;
        setIsOpen(true);
        abstractSessionStorage.setItem('hasBeenIncentivizedToRegister', true);
      }, _10Seconds);
    }
  }, [hasBeenIncentivizedDuringThisSession, wasLoggedInOnce, user]);

  return (
    <Modal isOpen={isOpen} close={() => setIsOpen(false)} maxWidth={{ lg: '900px' }} overflow="hidden">
      <Box mx={4} data-cy="modal-incentivizeToRegister" p={{ _: 2, md: 5 }} textAlign="center">
        <Text tag="h1" styleName="wH3" mb={3}>
          {t('mission:incentivizeToRegister:line1')}
        </Text>
        <Text my={3}>
          <SanitizedHTML content={t('mission:incentivizeToRegister:line2')} />
        </Text>
        <Text my={3}>
          <SanitizedHTML content={t('mission:incentivizeToRegister:line3')} />
        </Text>
        <Text my={3}>
          <SanitizedHTML content={t('mission:incentivizeToRegister:line4')} />
        </Text>
        <Box mb={3}>
          <Button data-cy="createAccountViaIncentivizeModal" shape="rounded">
            <Link to={register.to}>
              {t('mission:incentivizeToRegister:createAnAccount')}
            </Link>
          </Button>
        </Box>
        <Box>
          <Button data-cy="loginViaIncentivizeModal" styleType="transparent">
            <Link to={login.to}>
              {t('mission:incentivizeToRegister:alreadyHaveAnAccount')}
            </Link>
          </Button>
        </Box>
      </Box>
      <Box position="absolute" bottom="0" left="0" overflow="hidden" display={{ _: 'none', md: 'block' }}>
        <Img
          src={'/assets/waves/waveCorner1.webp'}
          srcRetina={'/assets/waves/waveCorner1@2x.webp'}
          fallback={'/assets/waves/waveCorner1.png'}
          fallbackRetina={'/assets/waves/waveCorner1@2x.png'}
          alt="section wave decoration"
          lazyloading={true}
          width={209}
          height={217}
        />
      </Box>

      <Box position="absolute" bottom="0" right="0" overflow="hidden" display={{ _: 'none', md: 'block' }}>
        <Img
          src={'/assets/waves/waveCorner2.webp'}
          srcRetina={'/assets/waves/waveCorner2@2x.webp'}
          fallback={'/assets/waves/waveCorner2.png'}
          fallbackRetina={'/assets/waves/waveCorner2@2x.png'}
          alt="section wave decoration"
          lazyloading={true}
          width={312}
          height={235}
        />
      </Box>
    </Modal>
  );
};

export default ModalIncentivizeToRegister;
